<script lang="ts">
    import { Router, Route } from 'svelte-tiny-router';
    import { auth } from './lib/stores/auth.svelte';
    import Login from './routes/Login.svelte';
    import Layout from './components/Layout.svelte';
    import Dashboard from './routes/Dashboard.svelte';
    import Secrets from './routes/Secrets.svelte';
    import MissingRequests from './routes/MissingRequests.svelte';
    import Consumers from './routes/Consumers.svelte';
    import Environments from './routes/Environments.svelte';
    import Subscriptions from './routes/Subscriptions.svelte';
    import Audit from './routes/Audit.svelte';
    import Backups from './routes/Backups.svelte';
    import Toasts from './components/Toasts.svelte';
</script>

<Toasts />

{#if !auth.isLoggedIn}
    <Login />
{:else}
    <Router>
        <Layout>
            <Route path="/"><Dashboard /></Route>
            <Route path="/secrets"><Secrets /></Route>
            <Route path="/missing"><MissingRequests /></Route>
            <Route path="/consumers"><Consumers /></Route>
            <Route path="/environments"><Environments /></Route>
            <Route path="/webhooks"><Subscriptions /></Route>
            <Route path="/audit"><Audit /></Route>
            <Route path="/backups"><Backups /></Route>
        </Layout>
    </Router>
{/if}
